import { Navigate } from 'react-router-dom';

const DashboardsView = async () =>
    import('../../pages/dashboards/ViewerPage').then((module) => ({
        Component: module.ViewerPage,
    }));

const getDashboardRoutes = (user) => {
    if (user?.carrierId) return [];

    return [
        {
            path: '/logistic-management/analytics',
            element: <Navigate to='/analytics/' />,
        },
        {
            path: '/analytics-new/', // Old temp URL
            element: <Navigate to='/analytics/' />,
        },
        {
            path: '/analytics/',
            lazy: DashboardsView,
        },
    ];
};

export { getDashboardRoutes };
